(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["founder-section"] && !Shopify.designMode) return;
  try {
    
function initFounderSections() {
  var sections = document.querySelectorAll('.founder-section:not([data-founder-initialized])');
  var reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var REVEAL_START = 0.85;
  var REVEAL_END = 0.45;

  function observeFadeInUpElements(root) {
    var fadeTargets = root.querySelectorAll('.fadeInUp:not([data-scroll="in"])');
    if (!fadeTargets.length) return;

    if (reduceMotion) {
      fadeTargets.forEach(function (el) {
        el.setAttribute('data-scroll', 'in');
      });
      return;
    }

    if ('IntersectionObserver' in window) {
      var fadeObserver = new IntersectionObserver(
        function (entries) {
          entries.forEach(function (entry) {
            if (!entry.isIntersecting) return;
            entry.target.setAttribute('data-scroll', 'in');
            fadeObserver.unobserve(entry.target);
          });
        },
        { threshold: 0.15, rootMargin: '0px 0px -5% 0px' }
      );

      fadeTargets.forEach(function (el) {
        fadeObserver.observe(el);
      });
    } else {
      fadeTargets.forEach(function (el) {
        el.setAttribute('data-scroll', 'in');
      });
    }
  }

  function easeOutCubic(t) {
    return 1 - Math.pow(1 - t, 3);
  }

  function wrapWordsInElement(element) {
    var walker = document.createTreeWalker(element, NodeFilter.SHOW_TEXT, {
      acceptNode: function (node) {
        return node.textContent.trim() ? NodeFilter.FILTER_ACCEPT : NodeFilter.FILTER_REJECT;
      }
    });

    var textNodes = [];
    while (walker.nextNode()) {
      textNodes.push(walker.currentNode);
    }

    textNodes.forEach(function (textNode) {
      var parts = textNode.textContent.split(/(\s+)/);
      var fragment = document.createDocumentFragment();

      parts.forEach(function (part) {
        if (!part) return;

        if (/^\s+$/.test(part)) {
          fragment.appendChild(document.createTextNode(part));
          return;
        }

        var word = document.createElement('span');
        word.className = 'founder-section__word';
        word.textContent = part;
        fragment.appendChild(word);
      });

      textNode.parentNode.replaceChild(fragment, textNode);
    });
  }

  function cloneQuote(source) {
    if (!source) return null;

    var quote = source.cloneNode(true);
    quote.classList.add('founder-section__word');
    return quote;
  }

  function insertQuote(layer, quote, position) {
    if (!layer || !quote) return;

    var target = layer.querySelector('p') || layer;
    if (position === 'start') {
      target.insertBefore(quote, target.firstChild);
    } else {
      target.appendChild(quote);
    }
  }

  function placeInlineQuotes(descriptionWrap) {
    var headingGroup = descriptionWrap.closest('.founder-section__heading-group');
    if (!headingGroup) return;

    var openSource = headingGroup.querySelector(':scope > .founder-section__quote--open');
    var closeSource = headingGroup.querySelector(':scope > .founder-section__quote--close');
    var items = descriptionWrap.querySelectorAll('.founder-section__paragraph');
    if (!items.length) return;

    var firstLayers = items[0].querySelectorAll('.founder-section__description');
    var lastLayers = items[items.length - 1].querySelectorAll('.founder-section__description');

    firstLayers.forEach(function (layer) {
      insertQuote(layer, cloneQuote(openSource), 'start');
    });
    lastLayers.forEach(function (layer) {
      insertQuote(layer, cloneQuote(closeSource), 'end');
    });

    if (openSource) openSource.remove();
    if (closeSource) closeSource.remove();
  }

  function wrapDescriptionParagraphs(descriptionWrap) {
    if (descriptionWrap.dataset.paragraphsWrapped === 'true') return;

    var source = descriptionWrap.querySelector('.founder-section__description--source');
    if (!source) return;

    var paragraphs = source.querySelectorAll('p');
    if (!paragraphs.length) {
      var item = document.createElement('div');
      item.className = 'founder-section__paragraph';

      var ghostLayer = document.createElement('div');
      ghostLayer.className = 'founder-section__description founder-section__description--ghost f_w_m color_white';
      ghostLayer.innerHTML = source.innerHTML;

      var revealLayer = document.createElement('div');
      revealLayer.className = 'founder-section__description founder-section__description--reveal f_w_m color_white';
      revealLayer.innerHTML = source.innerHTML;

      wrapWordsInElement(ghostLayer);
      wrapWordsInElement(revealLayer);

      item.appendChild(ghostLayer);
      item.appendChild(revealLayer);
      descriptionWrap.appendChild(item);
    } else {
      paragraphs.forEach(function (paragraph) {
        var item = document.createElement('div');
        item.className = 'founder-section__paragraph';

        var ghostLayer = document.createElement('div');
        ghostLayer.className = 'founder-section__description founder-section__description--ghost f_w_m color_white';
        ghostLayer.appendChild(paragraph.cloneNode(true));

        var revealLayer = document.createElement('div');
        revealLayer.className = 'founder-section__description founder-section__description--reveal f_w_m color_white';
        revealLayer.appendChild(paragraph.cloneNode(true));

        wrapWordsInElement(ghostLayer);
        wrapWordsInElement(revealLayer);

        item.appendChild(ghostLayer);
        item.appendChild(revealLayer);
        descriptionWrap.appendChild(item);
      });
    }

    source.remove();
    placeInlineQuotes(descriptionWrap);
    descriptionWrap.dataset.paragraphsWrapped = 'true';
  }

  function getWordRevealProgress(wordIndex, totalWords, paragraphProgress) {
    if (totalWords <= 0) return 0;
    if (paragraphProgress <= 0) return 0;
    if (paragraphProgress >= 1) return 1;

    var start = wordIndex / totalWords;
    var end = (wordIndex + 1) / totalWords;

    if (paragraphProgress <= start) return 0;
    if (paragraphProgress >= end) return 1;

    return (paragraphProgress - start) / (end - start);
  }

  function getParagraphRevealProgress(paragraphEl) {
    var rect = paragraphEl.getBoundingClientRect();
    var vh = window.innerHeight;

    if (rect.top >= vh) return 0;
    if (rect.bottom <= 0) return 1;
    if (rect.top <= vh * REVEAL_END) return 1;
    if (rect.top >= vh * REVEAL_START) return 0;

    return (vh * REVEAL_START - rect.top) / (vh * REVEAL_START - vh * REVEAL_END);
  }

  sections.forEach(function (section) {
    section.setAttribute('data-founder-initialized', 'true');
    observeFadeInUpElements(section);

    if (reduceMotion) {
      var descriptionWrap = section.querySelector('.founder-section__description-wrap');
      if (descriptionWrap) {
        wrapDescriptionParagraphs(descriptionWrap);
        descriptionWrap.querySelectorAll('.founder-section__description--reveal .founder-section__word').forEach(function (word) {
          word.style.setProperty('--reveal', '100%');
        });
      }
      return;
    }
  });

  if (reduceMotion) return;

  sections.forEach(function (section) {
    var descriptionWrap = section.querySelector('.founder-section__description-wrap');
    if (!descriptionWrap) return;

    wrapDescriptionParagraphs(descriptionWrap);

    var words = descriptionWrap.querySelectorAll('.founder-section__description--reveal .founder-section__word');
    if (!words.length) return;

    var ticking = false;

    function update() {
      var progress = getParagraphRevealProgress(descriptionWrap);
      var totalWords = words.length;

      words.forEach(function (word, index) {
        var wordProgress = easeOutCubic(getWordRevealProgress(index, totalWords, progress));
        word.style.setProperty('--reveal', (wordProgress * 100).toFixed(1) + '%');
      });
      ticking = false;
    }

    function onScroll() {
      if (!ticking) {
        window.requestAnimationFrame(update);
        ticking = true;
      }
    }

    window.addEventListener('scroll', onScroll, { passive: true });
    window.addEventListener('resize', onScroll);
    update();
  });
}

document.addEventListener('DOMContentLoaded', initFounderSections);
document.addEventListener('shopify:section:load', initFounderSections);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["our-story-section"] && !Shopify.designMode) return;
  try {
    
  function initOurStorySections() {
    var sections = document.querySelectorAll('.our-story-section:not([data-story-initialized])');
    var reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    function useFadeInUp() {
      return window.matchMedia('(max-width: 1024px)').matches;
    }

    function observeFadeInUp(section) {
      var fadeTargets = section.querySelectorAll('.fadeInUp');
      if (!fadeTargets.length) return;

      function setFadeState(isIn) {
        fadeTargets.forEach(function (el) {
          if (isIn) {
            el.setAttribute('data-scroll', 'in');
          } else {
            el.removeAttribute('data-scroll');
          }
        });
      }

      if (reduceMotion) {
        setFadeState(true);
        return;
      }

      if (!('IntersectionObserver' in window)) {
        setFadeState(true);
        return;
      }

      var content = section.querySelector('.our-story-section__content') || section;
      var fadeObserver = new IntersectionObserver(
        function (entries) {
          entries.forEach(function (entry) {
            if (!useFadeInUp()) {
              setFadeState(true);
              return;
            }
            setFadeState(entry.isIntersecting);
          });
        },
        { threshold: 0.35 }
      );
      fadeObserver.observe(content);
    }

    if (reduceMotion) {
      sections.forEach(function (section) {
        section.setAttribute('data-story-initialized', 'true');
        observeFadeInUp(section);
      });
      return;
    }

    var VIEWPORT_TRIGGER = 0.45;
    var ALIGN_SCROLL_DISTANCE = 280;
    var IMAGE_SCALE_START = 1.15;
    var IMAGE_SCALE_END = 1;
    var IMAGE_TRIGGER = 0.92;
    var IMAGE_PARALLAX_DISTANCE = 850;
    var EXTRA_SLIDE = 80;
    var SCROLL_DOWN = 30;

    function easeOutCubic(t) {
      return 1 - Math.pow(1 - t, 3);
    }

    sections.forEach(function (section) {
      section.setAttribute('data-story-initialized', 'true');
      observeFadeInUp(section);

      var rightBox = section.querySelector('.right_box');
      var picture = section.querySelector('.our-story-section__picture');
      var image = section.querySelector('.our-story-section__image');
      var ticking = false;

      var basePadding = rightBox ? parseFloat(window.getComputedStyle(rightBox).paddingTop) || 0 : 0;
      var startOffset = basePadding + EXTRA_SLIDE;

      function getAlignProgress() {
        var rect = section.getBoundingClientRect();
        var vh = window.innerHeight;
        var triggerY = vh * VIEWPORT_TRIGGER;

        if (rect.top >= triggerY) return 0;

        var scrolled = triggerY - rect.top;
        return Math.min(scrolled / ALIGN_SCROLL_DISTANCE, 1);
      }

      function getScrollProgress() {
        var rect = section.getBoundingClientRect();
        var vh = window.innerHeight;
        var triggerY = vh * VIEWPORT_TRIGGER;
        var alignEndTop = triggerY - ALIGN_SCROLL_DISTANCE;

        if (rect.top >= alignEndTop) return 0;

        var scrollDistance = alignEndTop + rect.height;
        var scrolled = alignEndTop - rect.top;
        return Math.min(Math.max(scrolled / scrollDistance, 0), 1);
      }

      function getImageProgress() {
        if (!picture) return 0;

        var rect = picture.getBoundingClientRect();
        var vh = window.innerHeight;
        var triggerY = vh * IMAGE_TRIGGER;

        if (rect.top >= triggerY) return 0;

        var scrolled = triggerY - rect.top;
        return Math.min(scrolled / IMAGE_PARALLAX_DISTANCE, 1);
      }

      function update() {
        var isMobile = useFadeInUp();
        var imageProgress = easeOutCubic(getImageProgress());

        if (rightBox) {
          if (isMobile) {
            rightBox.style.transform = '';
            rightBox.style.paddingTop = '';
          } else {
            var alignProgress = easeOutCubic(getAlignProgress());
            var scrollProgress = easeOutCubic(getScrollProgress());
            var translateY;
            var paddingTop;

            if (alignProgress < 1) {
              translateY = startOffset * (1 - alignProgress);
              paddingTop = basePadding * (1 - alignProgress);
            } else {
              translateY = SCROLL_DOWN * scrollProgress;
              paddingTop = 0;
            }

            rightBox.style.transform = translateY === 0
              ? 'none'
              : 'translateY(' + translateY.toFixed(1) + 'px)';
            rightBox.style.paddingTop = paddingTop.toFixed(1) + 'px';
          }
        }

        if (image) {
          var scale = IMAGE_SCALE_START - (IMAGE_SCALE_START - IMAGE_SCALE_END) * imageProgress;
          image.style.transform = 'scale(' + scale.toFixed(3) + ')';
        }

        ticking = false;
      }

      function onScroll() {
        if (!ticking) {
          window.requestAnimationFrame(update);
          ticking = true;
        }
      }

      window.addEventListener('scroll', onScroll, { passive: true });
      window.addEventListener('resize', onScroll);
      update();
    });
  }

  document.addEventListener('DOMContentLoaded', initOurStorySections);
  document.addEventListener('shopify:section:load', initOurStorySections);

  } catch(e) { console.error(e); }
})();
})();
